import { useMemo } from "react";
import { useMetaUtmEntites } from "features/dataConnectors/hooks/useMetaUtmEntites";


export const useSmartLinksSetup = () => {
  const { entites } = useMetaUtmEntites();

  const isSmartLinksSetup = useMemo(() => {
    return entites.some(
      (entity) =>
        (entity.landingPathId || 0) > 0 || (entity.rezonateUrl || "") !== ""
    );
  }, [entites]);

  return isSmartLinksSetup;
};

